import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  TextField,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  SimpleForm,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  ArrayField,
  NumberField,
  BooleanField,
  ReferenceField,
  SelectField,
  Filter,
} from 'react-admin'
import { ArchivalToolbar } from '../components/ArchivalToolbar'
import { ArchivedSelect } from '../components/selects'

const ListBase = (props) => {
  return (
    <List
      filters={<EventFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      {...props}
    >
      <EventList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <EventShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <EventForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <EventForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const EventFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <ArchivedSelect />
  </Filter>
)

const EventList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField label="Event Name" source="name" />
    <TextField label="Maximum # of Attempts" source="max_attempts" />
  </Datagrid>
)

const EventShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField source="name" />

    <NumberField label="Maximum # of Attempts" source="max_attempts" />

    <BooleanField label="Grade Entire Team" source="grade_entire_team" />

    <ReferenceField
      label="Alternate Event"
      source="fallback_event_id"
      reference="events"
    >
      <SelectField optionText="name" />
    </ReferenceField>

    <ArrayField label="Event Observed Behaviors" source="behaviors">
      <SingleFieldList>
        <TextField label="Behavior" source="name" />
      </SingleFieldList>
    </ArrayField>
  </SimpleShowLayout>
)

const EventForm = (props) => (
  <SimpleForm toolbar={<ArchivalToolbar />} warnWhenUnsavedChanges {...props}>
    <TextInput
      fullWidth
      label="Event Name"
      source="name"
      style={{ flex: 1, marginRight: 16 }}
    />
    <NumberInput
      fullWidth
      label="Maximum # of Attempts"
      source="max_attempts"
      min={0}
      style={{ flex: 1, marginRight: 16 }}
    />
    <BooleanInput
      fullWidth
      label="Grade Entire Team"
      defaultValue={false}
      source="grade_entire_team"
      style={{ flex: 1 }}
    />

    <ReferenceInput
      fullWidth
      allowEmpty={false}
      perPage={100}
      label="Alternate Event"
      source="fallback_event_id"
      reference="events"
    >
      <SelectInput optionText="name" />
    </ReferenceInput>

    <ArrayInput label="Event Observed Behaviors" source="behaviors">
      <SimpleFormIterator>
        <TextInput fullWidth label="Behavior" source="name" />
      </SimpleFormIterator>
    </ArrayInput>
  </SimpleForm>
)
